module.exports = __webpack_public_path__ + "static/media/data warehouse.3bb21aff.png";